module.exports = __webpack_public_path__ + "img/banner.53b6b45f.jpg";